// Menu value of "No perimeter"; an empty string means nothing is chosen yet.
export const NO_PERIMETER_CHOICE = "__no_perimeter__";

const MISSION_PERIMETER_ERROR_KEYS = {
    PERIMETER_REQUIRED: "perimeters.missionStep.errors.required",
    PERIMETER_FORBIDDEN: "perimeters.missionStep.errors.forbidden",
    PERIMETER_ARCHIVED: "perimeters.missionStep.errors.archived",
    PERIMETER_NOT_FOUND: "perimeters.missionStep.errors.notFound",
};

// The block of the Details step only shows when the api says so explicitly: a
// missing or odd answer keeps the journey as it was before perimeters.
export const isPerimeterStepShown = (options) =>
    Boolean(options) &&
    options.hidden === false &&
    Array.isArray(options.perimeters);

export const isPerimeterChoiceAvailable = (options, choice) => {
    if (!isPerimeterStepShown(options) || !choice) return false;
    if (choice === NO_PERIMETER_CHOICE) return Boolean(options.allowNone);
    return options.perimeters.some((perimeter) => perimeter.id === choice);
};

export const getDefaultPerimeterChoice = (options) => {
    if (isPerimeterChoiceAvailable(options, options?.preselectedId)) {
        return options.preselectedId;
    }
    return options?.allowNone ? NO_PERIMETER_CHOICE : "";
};

// null tells the api "no perimeter", which differs from leaving the field out.
export const toPerimeterIdPayload = (choice) =>
    choice === NO_PERIMETER_CHOICE ? null : choice;

// Message key for a perimeter refusal of mission/add, or null for any other error.
export const getMissionPerimeterErrorKey = (err) =>
    MISSION_PERIMETER_ERROR_KEYS[err?.response?.data?.errorCode] || null;
